import React from "react";
import { FilterOutlined, TagOutlined } from "@ant-design/icons";
import { Badge, Button } from "antd";
import clsx from "clsx";
import { useTranslations } from "translations/useTranslations";

import { useCheckDataset } from "modules/MatchingModule/helpers/useCheckDataset";
import { MatchedProductDrawer } from "modules/MatchingModule/MatchingGroupsModule/components/MatchedProductDrawer";
import { useMatchedProductFilter } from "modules/MatchingModule/MatchingGroupsModule/components/MatchedProductDrawer/hooks/useMatchedProductFilter";
import { MatchingFacets } from "modules/MatchingModule/MatchingGroupsModule/components/MatchingFacets";
import { MatchingSearch } from "modules/MatchingModule/MatchingGroupsModule/components/MatchingSearch";
import { MatchingSort } from "modules/MatchingModule/MatchingGroupsModule/components/MatchingSort";

import { MatchingTableControlsProps } from "./MatchingTableControls.types";

export const MatchingTableControls = React.memo<MatchingTableControlsProps>(({ className }) => {
  const translations = useTranslations();
  const [isFacetsOpen, setIsFacetsOpen] = React.useState(false);
  const [isMatchedProductOpen, setIsMatchedProductOpen] = React.useState(false);
  const { brandId } = useMatchedProductFilter();
  // Only transactions are matched to branded products
  const { isTransactions } = useCheckDataset();

  const openFacets = React.useCallback(() => setIsFacetsOpen(true), []);
  const closeFacets = React.useCallback(() => setIsFacetsOpen(false), []);
  const openMatchedProduct = React.useCallback(() => setIsMatchedProductOpen(true), []);
  const closeMatchedProduct = React.useCallback(() => setIsMatchedProductOpen(false), []);

  return (
    <>
      <div className={clsx("flex justify-between gap-4", className)}>
        <Button icon={<FilterOutlined />} onClick={openFacets}>{translations["matching.table.facets.button"]}</Button>
        {isTransactions && (
          <Badge dot={Boolean(brandId)}>
            <Button icon={<TagOutlined />} onClick={openMatchedProduct}>
              {translations["matching.table.matched_product.button"]}
            </Button>
          </Badge>
        )}
        <div className="grow"><MatchingSort /></div>
        <div className="grow"><MatchingSearch /></div>
      </div>
      <MatchingFacets isOpen={isFacetsOpen} onClose={closeFacets} />
      {isTransactions && <MatchedProductDrawer isOpen={isMatchedProductOpen} onClose={closeMatchedProduct} />}
    </>
  );
});
